import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import SessionStorageService from '../../services/sessionStorageService';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const ENV = process.env.REACT_APP_ENV;
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  devTools: ENV === 'dev',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true, // Disable middleware thunk if you don't need
      serializableCheck: false, // Disable serialization check if necessary
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

store.subscribe(() => {
  SessionStorageService.setAccountTab(
    store.getState().appManager.selectedAccountTab,
  );
});
store.subscribe(() => {
  SessionStorageService.setAssistanceTab(
    store.getState().appManager.selectedAssistanceTab,
  );
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
